module.exports = __webpack_public_path__ + "static/media/icon-edit.f0d23460.svg";